import cn from "clsx";
import { getWeekDaysInfo } from "../constants";
import { useLearningPlanTranslation } from "../hooks/useLearningPlanTranslation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProgressMetrics = function ProgressMetrics(_ref) {
  var className = _ref.className,
    style = _ref.style,
    progress = _ref.progress,
    isDark = _ref.isDark,
    currentDayIndex = _ref.currentDayIndex;
  var _useLearningPlanTrans = useLearningPlanTranslation(),
    t = _useLearningPlanTrans.t,
    languageKey = _useLearningPlanTrans.languageKey;
  var WEEK_DAYS = getWeekDaysInfo(languageKey);
  var highlightedBarBgCls = isDark ? 'bg-base-lighter-56' : 'bg-gray-light';
  var barBgCls = isDark ? 'bg-base-lighter-24' : 'bg-gray-lighter';
  var barCls = isDark ? 'bg-secondary-light' : 'bg-primary-main';
  var highlightedText = cn('border-b-2 border-solid pb-2', isDark ? 'text-secondary-light border-secondary-light' : 'text-primary-main border-primary-main');
  var maxSeconds = 0;
  progress.week.forEach(function (_ref2) {
    var seconds = _ref2.seconds;
    if (seconds > maxSeconds) {
      maxSeconds = seconds;
    }
  });
  return /*#__PURE__*/_jsxs("div", {
    style: style,
    className: cn('w-full h-full flex flex-col rounded-5 p-12', isDark ? 'bg-gray-main-dark-mode text-white' : 'bg-white text-base-dark shadow-1-dp', className),
    children: [/*#__PURE__*/_jsx("h3", {
      className: "font-subtitle3 mb-12",
      children: t('PROGRESS_TITLE')
    }), /*#__PURE__*/_jsx("div", {
      className: "flex justify-between w-full px-12",
      children: progress.week.map(function (_ref3) {
        var day = _ref3.day,
          seconds = _ref3.seconds;
        var isCurrentDay = WEEK_DAYS[day].index === currentDayIndex;
        var progressValue = maxSeconds && seconds ? seconds / maxSeconds * 100 : 0;
        return /*#__PURE__*/_jsxs("div", {
          className: cn('flex flex-col items-center font-caption', isCurrentDay ? highlightedText : 'text-gray-dark'),
          role: "progressbar",
          "aria-valuenow": Math.round(progressValue),
          "aria-valuemin": 0,
          "aria-valuemax": 100,
          children: [/*#__PURE__*/_jsx("div", {
            className: cn('w-16 h-64 mb-8 flex items-end rounded-10 overflow-hidden', isCurrentDay ? highlightedBarBgCls : barBgCls),
            children: /*#__PURE__*/_jsx("div", {
              className: cn("w-full", barCls),
              style: {
                height: "".concat(progressValue, "%")
              }
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "sm:hidden",
            children: WEEK_DAYS[day].initial
          }), /*#__PURE__*/_jsx("span", {
            className: "hidden sm:inline",
            children: WEEK_DAYS[day].label
          })]
        }, "day-".concat(day));
      })
    })]
  });
};
export default ProgressMetrics;